type CaptionGridCell = {
  element?: { type?: { _text?: string }; align?: { _text?: string } }
  _attributes?: { colspan?: string | number; width?: string }
  _isColspanPlaceholder?: boolean
  _isGridColumnSpacer?: boolean
  _isRowspanPlaceholder?: boolean
  _isHiddenColumnSpacer?: boolean
}

function isSkippedCell(cell: CaptionGridCell | undefined): boolean {
  if (!cell) return true
  return Boolean(
    cell._isColspanPlaceholder ||
      cell._isGridColumnSpacer ||
      cell._isRowspanPlaceholder ||
      cell._isHiddenColumnSpacer,
  )
}

/**
 * Right-aligned Label + field rows (panel 4263).
 * First track is the visible label max-content: Swing weight 0, hidden rows
 * do not keep a percent gutter. Explicit td width (25%, 10px, bare share)
 * stays on the flex grid — panel 842.
 *
 * Tiles rows (cart panel 4247) opt out. SwingTileRow forces those panels
 * back to flex, and a subgrid here collapses the HTML card to one glyph
 * per line (`overflow-wrap: anywhere` + min-width 0).
 */
export function shouldUseCaptionGrid(
  rows: unknown,
  options?: { tilesEmbed?: boolean },
): boolean {
  if (options?.tilesEmbed) return false
  if (!Array.isArray(rows) || rows.length === 0) return false

  let pairs = 0
  for (const row of rows) {
    if (!Array.isArray(row)) return false
    const real = (row as CaptionGridCell[]).filter((cell) => !isSkippedCell(cell))
    if (real.some((cell) => String(cell?._attributes?.width ?? '').trim() !== '')) return false
    if (real.length === 0) continue
    if (real.length === 1) {
      const span = parseInt(String(real[0]?._attributes?.colspan ?? '1'), 10) || 1
      if (span < 2) return false
      continue
    }
    if (real.length !== 2) return false
    const label = real[0]
    const type = String(label?.element?.type?._text ?? '').trim().toLowerCase()
    if (type !== 'label') return false
    const span = parseInt(String(label?._attributes?.colspan ?? '1'), 10) || 1
    if (span !== 1) return false
    const align = String(label?.element?.align?._text ?? '').trim().toLowerCase()
    if (align !== 'right') return false
    pairs += 1
  }
  return pairs > 0
}
